import React, { PropTypes } from 'react';
import axios from './../../../constants/axios';
import { Well, Button } from 'react-bootstrap';

class ContactAddressList extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         contactAddresses: []
      };
   }

   componentDidMount() {
      const { contactId } = this.props;
      axios.get(`contacts/${contactId}/getAddresses`)
         .then((res) => {
            this.setState({
               contactAddresses: res.data
            });
         });
   }

   deleteAddress = (addressId) => {
      axios.delete(`contacts/deleteContactAddress/${addressId}`)
         .then((res) => {
            if (res.status === 204) {
               const { contactAddresses } = this.state;
               this.setState({
                  contactAddresses: contactAddresses.filter((cAddress) => cAddress.id !== addressId)
               });
            }
         });
   };

   render() {
      const { contactAddresses } = this.state;
      const { toggleShowForm } = this.props;
      return (
         <div>
            <h4>
               Contact Addresses {" "}
               <Button bsStyle="info" onClick={toggleShowForm} >Create New Address</Button>
            </h4>
            {contactAddresses.map((cAddress) => (
               <Well key={cAddress.id} >
                  <pre>Address: {cAddress.address}</pre>
                  <p>District: {cAddress.district_name}</p>
                  <p>Thana: {cAddress.thana_name}</p>
                  <p>Address Type: {cAddress.contact_address_type_name}</p>
                  <Button bsStyle="danger" onClick={() => this.deleteAddress(cAddress.id)} >Delete</Button>
               </Well>
            ))}
         </div>
      );
   }
}

ContactAddressList.propTypes = {
   contactId: PropTypes.string,
   toggleShowForm: PropTypes.func,
};

export  default ContactAddressList;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/ContactDetail/ContactAddressList.js
 **/